const getSubTreeWithId = (tree, id) => {
  if (tree.id === id) {
    return tree;
  }
  let result = null;
  tree.children.forEach(c => {
    let r = getSubTreeWithId(c, id);
    if (r) {
      result = r;
    }
  });
  return result;
};

export default getSubTreeWithId;
